import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionsService } from '../auth/permissions.service';

export const DefaultSiteGuard: CanActivateFn = (next: ActivatedRouteSnapshot): Observable<boolean> => {
  return inject(PermissionsService).redirectToDefaultSite$(next);
};

export const SiteAccessGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  return inject(PermissionsService).hasSiteAccess$(next, state);
};

export const GlobalAdminGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(PermissionsService).isGlobalAdmin$();
};
